import Card from '@/global/components/Card'
import { Button } from 'global/components/Button'
import { PlusIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { ErroDaLista } from './ErroDaLista'

interface ListaFieldProps {
    name: 'condicoes' | 'acoes'
    rotuloAdicionar: string
    onAdicionar: () => void
    children: ReactNode
}

/** Moldura das listas da rotina: itens empilhados, erro da lista e botão de adicionar. */
export function ListaField({
    name,
    rotuloAdicionar,
    onAdicionar,
    children,
}: ListaFieldProps) {
    return (
        <Card className="dark:bg-background border">
            <div className="flex gap-2 flex-col">{children}</div>
            <div className="flex flex-row mt-4 gap-4">
                <Button
                    variant="text"
                    startIcon={<PlusIcon />}
                    onClick={onAdicionar}
                >
                    {rotuloAdicionar}
                </Button>
                <ErroDaLista name={name} />
            </div>
        </Card>
    )
}
